<div class="container p-2">
  <div class="row">
      <mat-form-field appearance="outline" class="col-md-3">
        <mat-label>Select Centre</mat-label>
        <mat-select  [(ngModel)]="selectedCentre" (selectionChange)="search()">
          <mat-option *ngFor=" let c of (centres$|async) "
                      [value]="c.centreCode">{{c.centreName}} </mat-option>
          <!--      <mat-option  value="All">All Centres</mat-option>-->
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class=" col-md-3">
        <mat-label>Select Child</mat-label>
        <mat-select [(ngModel)]="selectedChildCode" (selectionChange)="searchChild()" panelClass="custom-select-panel">
          <mat-select-trigger>
            {{ selectedChildCode ? selectedChildCode.firstName + ' ' + selectedChildCode.lastName : 'Select Child' }}
          </mat-select-trigger>
          <!-- Search Box -->
          <div class="mat-select-search">
            <input matInput [(ngModel)]="searchText" placeholder="Search" />
          </div>
          <!-- Filtered options -->
          <mat-option *ngFor="let c of childBycentre | async" [value]="c" style="height: auto">
            <ng-container *ngIf="!searchText || (c.firstName.toLowerCase().includes(searchText.toLowerCase()) || c.lastName.toLowerCase().includes(searchText.toLowerCase()))">
              {{ c.firstName }} {{ c.lastName }}
            </ng-container>
          </mat-option>
        </mat-select>
      </mat-form-field>
    <!-- add search box in selection option -->
    <div class=" col-md-3 d-flex justify-content-start gap-2">
      &nbsp;&nbsp;<button mat-mini-fab color="accent"  matTooltip="Search" (click)="SearchButton()"><mat-icon>search</mat-icon></button>&nbsp;&nbsp;&nbsp;&nbsp;
      &nbsp;&nbsp;<button mat-mini-fab color="accent"  (click)="clearAll()" matTooltip="Clear"><mat-icon>clear</mat-icon></button>
    </div>
  </div>
<div class="d-flex flex-column text-dark mx-4 ">
<mat-checkbox class="example-margin" [(ngModel)]="showIndividual">Show Individual Sessions</mat-checkbox>
<mat-checkbox class="example-margin" [(ngModel)]="showGroup"> Show Group Sessions</mat-checkbox>
<mat-checkbox class="example-margin" [(ngModel)]="showAssessment"> Show Assessments Sessions</mat-checkbox>
<mat-checkbox class="example-margin" [(ngModel)]="showFAssessment"> Show Follow Up Assessments Sessions</mat-checkbox>
</div>


<mat-form-field appearance="outline" class="col-md-3 mx-4" >
  <mat-label>Session Type</mat-label>
  <mat-select required  [(ngModel)]="sessionType" (selectionChange)="IndividualFilter($event)">
    <mat-option  value="All">All</mat-option>
    <mat-option *ngFor="let t of types" [value]="t">{{t}}</mat-option>
  </mat-select>
</mat-form-field>
<section  *ngIf="showIndividual" >
<h1>Individual Table</h1>
<div class="table-container">
  <table mat-table [dataSource]="dataSourceIndividual" class="mat-elevation-z8 " matSort>

    <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->



    <!-- Name Column -->
    <ng-container matColumnDef="childName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Child Name </th>
      <td mat-cell *matCellDef="let element"> {{element.childName}} </td>
    </ng-container>
    <ng-container matColumnDef="childCode">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Child Code </th>
      <td mat-cell *matCellDef="let element"> {{element.childCode}} </td>
    </ng-container>
    <!-- Weight Column -->
    <ng-container matColumnDef="centreName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Centre Name </th>
      <td mat-cell *matCellDef="let element"> {{element.centreName}} </td>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Session Date </th>
      <td mat-cell *matCellDef="let element"> {{(element.date).toDate() | date:'dd/MM/yyyy'}} </td>
    </ng-container>
    <!-- Position Column -->
    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>CreatedAt </th>

      <td mat-cell *matCellDef="let element"> <span *ngIf='element.createdAt' ></span> </td>

    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Session Type </th>

      <td mat-cell *matCellDef="let element"> <span *ngIf='element.createdAt' >{{element?.type }}</span> </td>

    </ng-container>

    <ng-container matColumnDef="Action">
      <th mat-header-cell *matHeaderCellDef>Action</th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button color="accent" (click)="viewDialog(element)" matTooltip="View">
          <mat-icon>remove_red_eye</mat-icon>
        </button>
      </td>
    </ng-container>
    <!-- Row shown when there is no matching data. -->
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="4"><span *ngIf="selectedCentre==null"> No Centre Selected</span>
    </tr>
    <tr mat-header-row *matHeaderRowDef="displayedColumns sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>


  </table>
  <mat-paginator [pageSizeOptions]="[25,50,100,200,250,500,1000]" ></mat-paginator>

</div>
</section>
<hr>
<mat-form-field appearance="outline" class="col-md-4">
  <mat-label>Session Topic</mat-label>
  <mat-select multiple [(ngModel)]="sessionTopics"  (selectionChange)="GroupFilter($event)">
    <mat-option value="All">All</mat-option>
    <mat-option value="Personal Hygiene">Personal Hygiene</mat-option>
    <mat-option value="Rules & Guidelines"> Rules & Guidelines</mat-option>
    <mat-option value="Bereavement"> Bereavement</mat-option>
    <mat-option value="Theme Base Session"> Theme Base Session</mat-option>
    <mat-option value="Covid-19 Pandemic"> Covid-19 Pandemic</mat-option>
    <mat-option value="Stress & Building Resilience"> Stress & Building Resilience</mat-option>
    <mat-option value="Any Activity"> Any Activity</mat-option>
    <mat-option value="Others"> Others</mat-option>
  </mat-select>
</mat-form-field>
<section *ngIf="showGroup">
<h1>Group Table</h1>
<section class="table-container">
  <table mat-table [dataSource]="dataSourceGroup" class="mat-elevation-z8" matSort>

    <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->

    <!-- Position Column -->
    <!--        <ng-container matColumnDef="position">-->
    <!--            <th mat-header-cell *matHeaderCellDef> No. </th>-->
    <!--            <td mat-cell *matCellDef="let element"> {{element.}} </td>-->
    <!--        </ng-container>-->
    <!-- Name Column -->
    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef> Created At </th>
      <td mat-cell *matCellDef="let element"> <span *ngIf='element.createdAt' >{{element?.createdAt|date:'dd/MM/yyyy' }}</span> </td>
    </ng-container>
    <!-- Name Column -->
    <ng-container matColumnDef="children">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Names </th>
      <td mat-cell *matCellDef="let element"> {{ getchildNames(element.children)}} </td>
    </ng-container>

    <!-- Weight Column -->
    <ng-container matColumnDef="centres">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Centres </th>
      <td mat-cell *matCellDef="let element"> {{getCenterNames(element.centres)}} </td>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="topicsCovered">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Topics Covered </th>
      <td mat-cell *matCellDef="let element">{{(getTopicsCovered(element.topicsCovered) )}} </td>
    </ng-container>
    <!-- Symbol Column -->
    <ng-container matColumnDef="participants">
      <th mat-header-cell *matHeaderCellDef> Participants </th>
      <td mat-cell *matCellDef="let element">{{(getTopicsCovered(element.participants) )}} </td>
    </ng-container>

    <ng-container matColumnDef="Action">
      <th mat-header-cell *matHeaderCellDef>Action</th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button color="primary" (click)="viewDialog2(element)" matTooltip="View"><mat-icon>remove_red_eye</mat-icon></button>

      </td>
    </ng-container>
    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef> Date of Session </th>
      <td mat-cell *matCellDef="let element"> {{(element.date).toDate() | date: 'dd/MM/yyyy' }} </td>
    </ng-container>
    <!-- Row shown when there is no matching data. -->
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="4"><span *ngIf="selectedCentre==''"> No Centre Selected</span>
    </tr>
    <tr mat-header-row *matHeaderRowDef="displayedColumns2 sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns2;"></tr>
  </table>
  <mat-paginator [pageSizeOptions]="[25,50,100,200,250,500,1000]" aria-label="Select page of users"></mat-paginator>

</section>
</section>
<hr>
<mat-form-field appearance="outline" class="col-md-4">
  <mat-label>Session Type</mat-label>
  <mat-select [(ngModel)]="sessionType3" (selectionChange)="assessmentFilter($event)">
    <mat-option  value ="All">ALL</mat-option>
    <mat-option *ngFor="let t of types3" [value]="t">{{t}}</mat-option>
  </mat-select>
</mat-form-field>
<section  *ngIf="showAssessment" class="table-container">

  <h1>Assessment Table</h1>

  <table mat-table [dataSource]="dataSourceAssessment" class="mat-elevation-z8" matSort>

    <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->

    <!-- Position Column -->
    <ng-container matColumnDef="childName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Child Name</th>
      <td mat-cell *matCellDef="let element"> {{element.childName}} </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="centreName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Centre</th>
      <td mat-cell *matCellDef="let element"> {{element.centreName}} </td>
    </ng-container>

    <!-- Weight Column -->
    <ng-container matColumnDef="parentsName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Parents Name</th>
      <td mat-cell *matCellDef="let element"> {{element.parentsName}} </td>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="conducted_by">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Conducted By</th>
      <td mat-cell *matCellDef="let element"> {{element.personConductingTest}} </td>
    </ng-container>

    <ng-container matColumnDef="dateOfAssessment">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Assessment Date</th>
      <td mat-cell *matCellDef="let element"> {{(element.dateOfAssessment).toDate()|date: 'dd/MM/yyyy'}} </td>
    </ng-container>

    <ng-container matColumnDef="sessionType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Session Type</th>
      <td mat-cell *matCellDef="let element"> {{element.type}} </td>
    </ng-container>
    <ng-container matColumnDef="Action">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button color="accent" (click)="viewAssessment(element)" matTooltip="View"><mat-icon>remove_red_eye</mat-icon></button>

      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns3 sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns3;"></tr>

  </table>
  <mat-paginator [pageSizeOptions]="[25,50,100,200,250,500,1000]" aria-label="Select page of users"></mat-paginator>

</section>


<section *ngIf="dataSourceAssessment.data.length>=1">
  <app-graph-list-horizontal type="Assessment" [mAssessments]="dataSourceAssessment.data"></app-graph-list-horizontal>

  <div class="grid-container"style="padding: 50px">
  <h4 > <strong>Average</strong></h4>
    <div class="row row-cols-1 row-cols-md-3 g-4 ">
        <div class=" typecenter" >
          <canvas baseChart
                  [labels]="doughnutChartLabels"
                  [datasets]="doughnutChartDatasets"
                  [options]="doughnutChartOptions"
                  [legend]="true"
                  [type]="'doughnut'" >

          </canvas>&nbsp;
          <div class="text-center">
<!--            <label class="text-center"> <strong>Average Graph</strong></label>-->
        </div>
        </div>
    </div>
  </div>

        <!--  <canvas baseChart-->
        <!--          [labels]="doughnutChartLabels"-->
        <!--          [datasets]="doughnutChartDatasets3"-->
        <!--          [options]="doughnutChartOptions"-->
        <!--          [legend]="true"-->
        <!--          [type]="'doughnut'" >-->

        <!--  </canvas>&nbsp;-->
        <!--  <label class="typecenter"> <b>AL Pune Center</b></label>-->


</section>

<hr>
<section  *ngIf="showFAssessment" class="table-container">
  <mat-form-field appearance="outline" class="col-md-4">
    <mat-label>Session Type</mat-label>
    <mat-select [(ngModel)]="sessionType4" (selectionChange)="fassessmentFilter($event)">
      <mat-option  value ="All">ALL</mat-option>
      <mat-option *ngFor="let t of types4" [value]="t">{{t}}</mat-option>
    </mat-select>
  </mat-form-field>
  <h1>Followup Assessment Table</h1>

  <table mat-table [dataSource]="dataSourceFAssessment" class="mat-elevation-z8" matSort>

    <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->

    <!-- Position Column -->
    <ng-container matColumnDef="childName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Child Name</th>
      <td mat-cell *matCellDef="let element"> {{element.childName}} </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="centreName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Centre</th>
      <td mat-cell *matCellDef="let element"> {{element.centreName}} </td>
    </ng-container>

    <!-- Weight Column -->
<!--    <ng-container matColumnDef="parentsName">-->
<!--      <th mat-header-cell *matHeaderCellDef mat-sort-header> Parents Name</th>-->
<!--      <td mat-cell *matCellDef="let element"> {{element.parentsName}} </td>-->
<!--    </ng-container>-->

    <!-- Symbol Column -->
    <ng-container matColumnDef="submittedBy">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Conducted By</th>
      <td mat-cell *matCellDef="let element"> {{element.submittedBy}} </td>
    </ng-container>

    <ng-container matColumnDef="dateOfAssessment">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Assessment Date</th>
      <td mat-cell *matCellDef="let element"> {{(element.dateOfAssessment).toDate()|date: 'dd/MM/yyyy'}} </td>
    </ng-container>

    <ng-container matColumnDef="sessionType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Session Type</th>
      <td mat-cell *matCellDef="let element"> {{element.sessionType}} </td>
    </ng-container>
    <ng-container matColumnDef="Action">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button color="accent" (click)="viewFAssessment(element)" matTooltip="View"><mat-icon>remove_red_eye</mat-icon></button>

      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="FdisplayedColumns4 sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: FdisplayedColumns4;"></tr>

  </table>
  <mat-paginator [pageSizeOptions]="[25,50,100,200,250,500,1000]" aria-label="Select page of users"></mat-paginator>

</section>
<app-graph-list-horizontal type="FollowUp" [mAssessments]="dataSourceFAssessment.data"></app-graph-list-horizontal>


<section *ngIf="dataSourceFAssessment.data.length>=1">
  <div class="grid-container"style="padding: 50px">
    <h4 > <strong>Average</strong></h4>

    <div class="row row-cols-1 row-cols-md-3 g-4">
      <div class=" typecenter" >

        <canvas baseChart
                [labels]="doughnutChartLabels"
                [datasets]="doughnutFChartDatasets"
                [options]="doughnutChartOptions"
                [legend]="true"
                [type]="'doughnut'" >

        </canvas>&nbsp;
        <div class="text-center">
<!--          <label class="text-center"> <strong>Average</strong></label>-->
        </div>
      </div>
    </div>
  </div>
  <!--  <canvas baseChart-->
  <!--          [labels]="doughnutChartLabels"-->
  <!--          [datasets]="doughnutChartDatasets3"-->
  <!--          [options]="doughnutChartOptions"-->
  <!--          [legend]="true"-->
  <!--          [type]="'doughnut'" >-->

  <!--  </canvas>&nbsp;-->
  <!--  <label class="typecenter"> <b>AL Pune Center</b></label>-->


</section>
</div>
